module.exports = __webpack_public_path__ + "img/copyBtn.120ed7a8.svg";